/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import React from 'react';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';

function ShipmentsSelector({
  shipments, selectedIndex, onSelect,
}) {
  const history = useHistory();

  const backgroundColour = '#fff';
  const borderColour = '#aaa';
  const fontColour = '#262626';
  const neutralGrey5 = '#f2f2f2';
  const neutralGrey10 = '#e6e6e6';
  const neutralGrey20 = '#cccccc';

  const selectStyle = {
    control: (base) => ({
      ...base,
      borderColor: borderColour,
      backgroundColor: backgroundColour,
      boxShadow: 'none',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: 'none',
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 0,
      boxShadow: 'none',
      border: `1px solid ${borderColour}`,
    }),
    menuList: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? neutralGrey5 : backgroundColour,
      color: fontColour,
      height: 40,
      fontSize: '0.8125rem',
      padding: 12,

      '&:hover': {
        backgroundColor: state.isSelected ? neutralGrey20 : neutralGrey10,
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: fontColour,
      fontSize: '14px',
      margin: 0,
    }),
  };

  const options = shipments.map((x, i) => ({ value: x.id, label: `Parcel ${i + 1} of ${shipments.length}` }));

  const searchValue = history?.location?.search;
  const pattern = /(?:tracking_reference|shipment_id)=([^&]+)/;
  const match = searchValue?.match(pattern);
  let currentShipmentValue;
  if (match && match[1]) {
    currentShipmentValue = shipments.find((ship) => ship.trackingReference === match[1] || ship.id === match[1]);
  } else {
    currentShipmentValue = null;
  }

  return (
    <Select
      options={options}
      value={options.find((x) => x.values === shipments[selectedIndex].id)}
      defaultValue={currentShipmentValue
        ? {
          value: currentShipmentValue.id,
          label: `Parcel ${shipments.findIndex((x) => x === currentShipmentValue) + 1} of ${shipments.length}`,
        }
        : options[0]}
      isSearchable={false}
      onChange={({ value }) => onSelect(shipments.findIndex((x) => x.id === value))}
      styles={selectStyle}
    />
  );
}

export default ShipmentsSelector;
